import { MembershipTypeNumbers } from '@components/_membership/progress-bar'
import { LoyaltyStatusQuery } from '@generated'

export function getLoyaltyProgress(data: LoyaltyStatusQuery) {
  if (
    !data ||
    !data.loyaltyStatus ||
    !data.loyaltyStatus.loyalty_nr ||
    !data.loyaltyStatus.loyalty_progress
  ) {
    return 0
  }

  const loyaltyNo = data.loyaltyStatus.loyalty_nr as MembershipTypeNumbers
  const progress = data.loyaltyStatus.loyalty_progress

  switch (loyaltyNo) {
    case 4:
      return progress / 2 < 10 ? 10 : progress / 2
    case 3:
      return 50 + progress / 2
    default:
      return 100
  }
}
